import makeStyles from '@mui/styles/makeStyles';
import React from "react";

interface BecomePatronProps {
  style?: React.CSSProperties;
  className?: string;
  _url: string;
}

const useStyles = makeStyles((theme) => ({
  root: {},
  div: {
    alignSelf: "center",
    alignItems: "center",
    display: "inline-flex",
    filter: "none",
    width: 179,
    justifyContent: "center",
  },
  a: {
    alignItems: "center",
    backfaceVisibility: "hidden",
    backgroundColor: "rgb(255, 66, 77)",
    borderRadius: "9999px",
    border: "1px solid rgb(255, 66, 77)",
    boxSizing: "border-box",
    cursor: "pointer",
    display: "inline-flex",
    height: 29,
    // width: "100%",
    // width: 169,
    justifyContent: "center",
    padding: theme.spacing(0, 2),
    // padding: "0.46875rem 1rem",
    position: "relative",
    pointerEvents: "unset",
    textAlign: "center",
    textDecoration: "none",
    textTransform: "none",
    transition: "all 300ms cubic-bezier(0.19, 1, 0.22, 1) 0s",
    userSelect: "none",
    whiteSpace: "unset",
    color: "rgb(255, 255, 255) !important",
    fontSize: "1.4375rem !important",
    fontFamily: "'Cookie', cursive !important",
  },
  svgSpan: { height: "1.8rem", width: "0.9rem", fill: "white" },
  text: { marginLeft: 8, whiteSpace: "nowrap" },
}));

export const BecomePatron: React.FC<BecomePatronProps> = ({ style, className, _url }) => {
  const classes = useStyles();
  if (!_url) return <></>;

  return (
    <div className={className} style={style}>
      <div className={classes.div}>
        <a className={classes.a} href={_url} target="_blank" rel="noopener noreferrer">
          <span className={classes.svgSpan}>
            <svg viewBox="0 0 569 546" xmlns="http://www.w3.org/2000/svg">
              <g>
                <circle cx="362.589996" cy="204.589996" data-fill="1" id="Oval" r="204.589996"></circle>
                <rect data-fill="2" height="545.799988" id="Rectangle" width="100" x="0" y="0"></rect>
              </g>
            </svg>
          </span>
          <span className={classes.text}>Become a Patron</span>
        </a>
      </div>
    </div>
  );
};

export default BecomePatron;
